import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import DashboardHeader from './DashboardHeader';
import DashboardSidebar from './DashboardSidebar';
import DashboardBottomNav from './DashboardBottomNav';
import './DashboardLayout.css';

export interface NavItem {
  path: string;
  icon: string;
  label: string;
  labelShort?: string; // etichetta bottom nav (se diversa)
  badgeCount?: number;
  end?: boolean; // exact match per NavLink
}

interface DashboardLayoutProps {
  navItems: NavItem[];
  areaLabel: string; // 'Dashboard' | 'Area Admin' | 'Super Admin'
  notifPath?: string; // path voce notifiche per badge header
  unreadCount?: number;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  navItems,
  areaLabel,
  notifPath,
  unreadCount = 0,
}) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  return (
    <div className="dl-layout">
      <DashboardHeader
        areaLabel={areaLabel}
        notifPath={notifPath}
        unreadCount={unreadCount}
      />
      <div className="dl-body">
        <DashboardSidebar
          navItems={navItems}
          collapsed={sidebarCollapsed}
          onToggle={() => setSidebarCollapsed((v) => !v)}
        />
        <main className="dl-main">
          <Outlet />
        </main>
      </div>
      <DashboardBottomNav navItems={navItems} />
    </div>
  );
};

export default DashboardLayout;
